import { render } from "./SolutionPage.vue?vue&type=template&id=51e70e40"
import script from "./SolutionPage.vue?vue&type=script&lang=js"
export * from "./SolutionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__